import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmumbai() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Mumbai ',
    heading: 'Shambhu Cabs: Corporate Cab Services in Mumbai',
    headingDescription: 'Shambhu Cabs offers professional Corporate Cab Services in Mumbai, providing safe, comfortable, and punctual transportation solutions for employees, clients, and executives across corporate offices, business hubs, and industrial areas. Our fleet of hatchbacks, sedans, SUVs, and premium cars ensures smooth and reliable travel for daily commutes, airport transfers, client meetings, and corporate events. With experienced chauffeurs, flexible rental plans, and well-maintained vehicles, Shambhu Cabs makes corporate travel seamless, efficient, and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted corporate cab services in Mumbai for businesses seeking comfort, safety, and dependable mobility solutions.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Corporate Taxi Mumbai",
    "description": "Corporate Taxi Mumbai provides reliable and professional taxi services tailored for corporate clients and business travelers. The service includes well-maintained sedans and SUVs with experienced chauffeurs who understand the importance of punctuality, professionalism, and comfort. Ideal for office transfers, client pickups, business meetings, and intercity corporate travel, this service ensures seamless, stress-free transportation with flexible packages and transparent pricing."
  },
  {
    "name": "Mumbai Employee Transport",
    "description": "Mumbai Employee Transport specializes in organized and timely employee commute solutions for companies in Mumbai. The service offers dedicated vans, SUVs, and sedans to safely transport employees to and from workplaces, ensuring comfort and reliability. Flexible schedules, route optimization, and professional drivers make it perfect for daily office commute, corporate events, and staff outings."
  },
  {
    "name": "Office Cab Service Mumbai",
    "description": "Office Cab Service Mumbai delivers premium transportation solutions for businesses, focusing on punctuality, safety, and convenience. Vehicles are equipped with AC, GPS tracking, and comfortable seating. The service covers daily employee pickups, client meetings, airport transfers, and executive travel, making it an ideal solution for seamless corporate mobility."
  },
  {
    "name": "Corporate Shuttle Mumbai",
    "description": "Corporate Shuttle Mumbai provides shuttle services for employees and business guests, offering scheduled pick-ups and drop-offs across multiple office locations. The service includes comfortable vans and SUVs with professional chauffeurs, ensuring timely, secure, and efficient transportation for corporate clients. Flexible packages can accommodate short-term events or long-term employee commute requirements."
  },
  {
    "name": "Business Travel Cabs Mumbai",
    "description": "Business Travel Cabs Mumbai caters specifically to corporate clients and business travelers who need reliable, punctual, and comfortable cab services. The fleet includes premium sedans and SUVs, professional drivers, and support for airport transfers, client visits, and intercity trips. Transparent pricing, on-demand bookings, and 24×7 availability ensure a seamless corporate travel experience."
  },
  {
    "name": "Corporate Car Rental Mumbai",
    "description": "Corporate Car Rental Mumbai offers chauffeur-driven cars for businesses and corporate clients. Perfect for executive travel, client meetings, and business events, the service includes sedans, SUVs, and luxury vehicles. With well-trained drivers, real-time tracking, and customized billing, companies can ensure smooth transportation for staff and guests alike."
  },
  {
    "name": "Staff Pickup & Drop Mumbai",
    "description": "Staff Pickup & Drop Mumbai provides organized and timely transport solutions for employees. The service features comfortable vehicles with experienced drivers, optimized routes, and reliable scheduling to ensure smooth daily commute. It caters to startups, corporate offices, and large enterprises looking for safe and cost-effective staff transport services."
  },
  {
    "name": "Mumbai Corporate Fleet",
    "description": "Mumbai Corporate Fleet offers dedicated corporate transportation solutions with a fleet of sedans, SUVs, and premium cars. Tailored for businesses, the service ensures punctual pickups, professional chauffeurs, and comprehensive support for employee commute, client visits, and corporate events. Flexible rental plans and transparent pricing make it a dependable choice for corporate mobility."
  },
  {
    "name": "Best Corporate Cabs Mumbai",
    "description": "Best Corporate Cabs Mumbai provides top-rated corporate taxi services emphasizing reliability, comfort, and professionalism. With a fleet of AC sedans, SUVs, and luxury cars, the service caters to executive travel, employee transport, airport transfers, and business meetings. 24×7 availability and efficient online booking ensure seamless corporate mobility."
  },
  {
    "name": "IT Company Cab Mumbai",
    "description": "IT Company Cab Mumbai specializes in employee transport for IT firms and tech companies. The service includes dedicated vans and cars with trained drivers, optimized routes, and timely pickups to ensure efficient commute. Flexible scheduling, real-time tracking, and safety protocols make it ideal for daily staff transport and corporate events."
  },
  {
    "name": "Mumbai Corporate Chauffeur",
    "description": "Mumbai Corporate Chauffeur offers professional chauffeur services for corporate clients, ensuring punctual, secure, and comfortable travel. Vehicles include sedans, SUVs, and luxury cars suitable for executive transport, airport transfers, and business trips. Trained drivers and attention to client preferences make the service ideal for high-standard corporate mobility."
  },
  {
    "name": "Monthly Corporate Cab Mumbai",
    "description": "Monthly Corporate Cab Mumbai provides subscription-based transport solutions for companies, allowing regular employee commute with a fixed monthly package. Vehicles include sedans and SUVs, driven by professional chauffeurs, with scheduled pickups and drops. This service ensures consistent, safe, and cost-effective transportation for corporate staff."
  },
  {
    "name": "Corporate Sedan Taxi Mumbai",
    "description": "Corporate Sedan Taxi Mumbai provides comfortable sedan taxis for business travel, client meetings, and office commutes. The service offers punctual pickups, well-maintained vehicles, professional drivers, and transparent pricing, ensuring a premium corporate travel experience in and around Mumbai."
  },
  {
    "name": "Corporate SUV Cab Mumbai",
    "description": "Corporate SUV Cab Mumbai offers spacious and comfortable SUVs for executive and group travel. Ideal for business meetings, airport transfers, and corporate events, the service features professional chauffeurs, flexible scheduling, and transparent fare options, ensuring reliable and stress-free transportation."
  },
  {
    "name": "Corporate Travel Solutions Mumbai",
    "description": "Corporate Travel Solutions Mumbai delivers end-to-end corporate transportation services including employee commute, client pickups, and intercity business travel. The service provides a fleet of sedans, SUVs, and premium vehicles with trained chauffeurs, ensuring safety, punctuality, and efficiency. Customizable plans and 24×7 support make it ideal for corporate mobility management."
  },
  {
    "name": "Premium Corporate Cab Mumbai",
    "description": "Premium Corporate Cab Mumbai offers luxury and high-end vehicles for executive and corporate travel. With sedans, SUVs, and chauffeur-driven luxury cars, the service ensures comfort, professionalism, and punctuality for business meetings, airport transfers, and VIP client visits. Flexible packages and online booking enhance convenience and reliability."
  },
  {
    "name": "Safe Employee Cab Mumbai",
    "description": "Safe Employee Cab Mumbai focuses on providing secure and reliable transportation for employees. The service includes GPS-tracked vehicles, trained drivers, and regular safety checks, ensuring peace of mind for corporate clients. Ideal for daily staff commute, airport pickups, and business trips, it combines comfort, safety, and efficiency."
  }
],

"tableData": [
  ["Corporate Taxi Mumbai", "Mumbai Employee Transport"],
  ["Office Cab Service Mumbai", "Corporate Shuttle Mumbai"],
  ["Business Travel Cabs Mumbai", "Corporate Car Rental Mumbai"],
  ["Staff Pickup & Drop Mumbai", "Mumbai Corporate Fleet"],
  ["Best Corporate Cabs Mumbai", "IT Company Cab Mumbai"],
  ["Mumbai Corporate Chauffeur", "Monthly Corporate Cab Mumbai"],
  ["Corporate Sedan Taxi Mumbai", "Corporate SUV Cab Mumbai"],
  ["Corporate Travel Solutions Mumbai", "Premium Corporate Cab Mumbai"],
  ["Safe Employee Cab Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides professional corporate cab services in Mumbai, ideal for office commutes, client meetings, and business travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to ensure a comfortable and productive journey for corporate clients."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Professional Travel",
    "WhyChoosedescription": "Our skilled drivers are punctual, professional, and familiar with Mumbai’s routes, ensuring timely and safe travel for your business needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear and upfront pricing—fuel, tolls, and driver allowances included—making corporate cab bookings hassle-free and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and corporate travel requirements."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Corporate Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized corporate rental plans tailored to your business schedules and requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All corporate cabs are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel environment."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your corporate travel in Mumbai smooth, comfortable, and professional."
  }
]





















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide corporate cab services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers professional corporate cab services in Mumbai, ensuring timely, safe, and comfortable travel for employees and business clients.',
  },
  {
    question: 'How can I book corporate cab services in Mumbai with Shambhu Cabs?',
    answer: 'You can book through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free corporate cab bookings.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Mumbai?',
    answer: 'Shambhu Cabs provides sedans, SUVs, and premium cars suitable for business travel, airport transfers, and employee transportation within Mumbai.',
  },
  {
    question: 'Are drivers experienced for corporate cab services in Mumbai?',
    answer: 'Yes, our drivers are professional, punctual, licensed, and well-trained to handle corporate transportation requirements efficiently.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for corporate cab services?',
    answer: 'Absolutely. You can select any pickup and drop-off locations within Mumbai according to your corporate travel needs.',
  },
  {
    question: 'Is corporate cab service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock corporate cab services to accommodate any business schedule or urgent travel requirement.',
  },
  {
    question: 'Are safety and hygiene protocols followed for corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene measures to ensure employee well-being during travel.',
  },
  {
    question: 'What payment options are available for corporate cab services in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and offer corporate account billing options for seamless transactions.',
  },
  {
    question: 'Is customer support available during corporate cab journeys in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout corporate cab trips in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Sharma',
    feedback: 'Shambhu Cabs’ corporate cab service in Mumbai is top-notch. Punctual, professional, and highly reliable for our employee transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Desai',
    feedback: 'Excellent corporate cab services! Shambhu Cabs makes business travel in Mumbai very convenient and hassle-free.',
    rating: 5,
  },
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/corporate-cab-mumbai.jpg",
  "description": "Shambhu Cabs offers premium corporate cab services in Mumbai for employee transportation, office commutes, and business travel. Choose from chauffeur-driven sedans, SUVs, and corporate fleet options for reliable, safe, and comfortable rides. Available 24×7 with monthly rental plans and corporate packages.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/corporate-cab-services-mumbai"
  }
};






  return (
    <div>
      <Helmet>
  <title>Corporate Cab Services Mumbai | Employee & Business Travel | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book corporate cab services in Mumbai with Shambhu Cabs. Chauffeur-driven sedans and SUVs for employee transport, office commutes, and business travel. Flexible corporate packages and monthly rentals available."
  />

  <meta
    name="keywords"
    content="Corporate Taxi Mumbai, Mumbai Employee Transport, Office Cab Service Mumbai, Corporate Shuttle Mumbai, Business Travel Cabs Mumbai, Corporate Car Rental Mumbai, Staff Pickup & Drop Mumbai, Mumbai Corporate Fleet, Best Corporate Cabs Mumbai, IT Company Cab Mumbai, Mumbai Corporate Chauffeur, Monthly Corporate Cab Mumbai, Corporate Sedan Taxi Mumbai, Corporate SUV Cab Mumbai, Corporate Travel Solutions Mumbai, Premium Corporate Cab Mumbai, Safe Employee Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmumbai;